import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  gridRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(3, 4),
  },
  statusChip: {
    width: 'fit-content',
    height: '20px',
  },
  label: {
    fontSize: '12px',
    lineHeight: '16px',
    color: theme.palette.labraText.description,
  },
}))
